import SEOHead from "@/components/General/SEOHead";
import Donate from "@/modules/Donate/Donate";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

const DonatePage = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <SEOHead
        title={t("donate.title")}
        description={t("donate.description")}
      />
      <Donate />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default DonatePage;
